<template>
  <div>

    <p class="view__title--sub" v-if="isScheduled">{{ L.localize("Campaign_ScheduledAt")}} {{ campaign.scheduledAt }}</p>

    <div class="buttons">
      <Btn :isLoading="loadingSend" v-if="!isScheduled" @click="triggerSend" float="right" label="Campaigns_SendNow" />
      <Btn :isLoading="loadingSendTest" @click="triggerSendTestModal" label="Campaigns_SendTest" />

      <!-- <Btn :isLoading="loadingScheduling" v-if="!isScheduled" @click="triggerSchedule" label="Campaigns_Schedule" />
      <Btn :isLoading="loadingScheduling" v-else @click="unschedule" label="Campaigns_Unschedule" /> -->
    </div>

    <article class="preview">
      <div class="preview__content" v-html="campaign.body" />
    </article>

    <sweet-modal :title="L.localize('Campaigns_Breadcrumb_SendTest')" ref="sendTestModal">
      <TextBox
        label="Label_EmailAddressesWithComma"
        v-model="model.emails"
        :validate="$v.model"
        modelPath="emails"
        acc="emails"

        @input="$v.model.emails.$touch"
      />

      <Btn v-on:click="sendTest" label="Send" />
    </sweet-modal>

    <sweet-modal :title="L.localize('Campaign_Schedule_Modal_Title')" ref="scheduleModal">
      <TextBox
        label="Label_ScheduleAt"
        v-model="scheduling.date"
        :validate="$v.scheduling"
        modelPath="date"
        acc="scheduledAt"
        type="datetime"

        @input="$v.scheduling.date.$touch"
      />

      <Btn v-on:click="schedule" label="Campaigns_Schedule" />
    </sweet-modal>

    <sweet-modal :title="L.localize('Campaigns_Breadcrumb_Send_Confirm_Title')" ref="sendNowModal">

      <p>{{ L.localize("Campaigns_Breadcrumb_Send_Confirm_Message") }}</p>

      <Btn v-on:click="send" label="Campaigns_SendNow" />
    </sweet-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { SweetModal } from 'sweet-modal-vue'
import { TextBox, Btn } from 'components/layout/forms'
import Submenu from 'components/views/campaigns/Submenu'
import L from 'services/Localization'
import notifications from 'mixins/notifications'
import { required } from 'vuelidate/lib/validators'
import { Validation } from 'components/helpers'

export default {
  name: 'campaign-preview',
  components: { Submenu, Validation, TextBox, Btn, SweetModal },
  mixins: [notifications],
  props: {
    campaign: {
      type: Object,
      required: true,
      default: []
    }
  },
  data() {
    return {
      loadingSendTest: false,
      loadingScheduling: false,
      loadingSend: false,
      L: L,
      model: {
        emails: ''
      },
      scheduling: {
        date: ''
      }
    }
  },
  validations: {
    model: {
      emails: { required }
    },
    scheduling: {
      date: { required }
    }
  },
  computed: {
    ...mapGetters({
      templates: 'allTemplates',
      activeCampaign: 'activeCampaign'
    }),
    isScheduled() {
      return this.activeCampaign.status === 'scheduled'
    }
  },
  methods: {
    triggerSend() {
      this.$refs.sendNowModal.open()
    },
    triggerSendTestModal() {
      this.$refs.sendTestModal.open()
    },
    triggerSchedule() {
      this.scheduling.date = this.campaign.scheduledAt
      this.$refs.scheduleModal.open()
    },
    schedule() {
      if (this.$v.scheduling.$invalid) {
        this.$v.scheduling.$touch()
        return;
      }
      this.loadingScheduling = true
      this.campaign.scheduledAt = this.scheduling.date
      this.$store.dispatch('scheduleCampaign', this.campaign).then(
        () => {
          this.showNotification({
            title: L.localize('Label_SuccessEdit'),
            message: L.localize('Campaign_HasBeenScheduled')
          })
          this.loadingScheduling = false
        },
        () => {
          window.alert('FAILED')
          this.loadingScheduling = false
        }
      )
      this.$refs.scheduleModal.close()
    },
    unschedule() {
      this.loadingScheduling = true
      this.$store.dispatch('unscheduleCampaign', this.campaign).then(
        () => {
          this.campaign.scheduledAt = null
          this.showNotification({
            title: L.localize('Label_SuccessEdit'),
            message: L.localize('Campaign_HasBeenUnscheduled')
          })
          this.loadingScheduling = false
        },
        () => {
          this.loadingScheduling = false
          window.alert('FAILED')
        }
      )
    },
    send() {
      this.loadingSend = true
      this.$store.dispatch('sendCampaign', this.campaign).then(
        () => {
          this.showNotification({
            title: L.localize('Label_SuccessEdit'),
            message: L.localize('Campaign_HasBeenSent')
          })
          this.loadingSend = false
          this.$router.push({name: 'campaigns'})
        },
        () => {
          window.alert('FAILED')
          this.loadingSend = false
        }
      )
      this.$refs.sendNowModal.close()
    },
    sendTest() {
      if (this.$v.model.$invalid) {
        this.$v.$touch()
        return;
      }
      this.loadingSendTest = true
      let request = {
        id: this.campaign.id,
        subject: this.campaign.subject,
        body: this.campaign.body,
        emails: this.model.emails.split(','),
        config: this.campaign.config
      }
      this.$store.dispatch('sendTest', request).then(
        () => {
          this.loadingSendTest = false
        },
        () => {
          this.loadingSendTest = false
          window.alert('FAILED')
        }
      )
      this.$refs.sendTestModal.close()
    }
  }
}
</script>



// WEBPACK FOOTER //
// CampaignPreview.vue?090af487